import { useDispatch } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat } from '../common/function';
import { getBrand } from '../../config/brand';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// dayjs timezone 플러그인 활성화
dayjs.extend(utc);
dayjs.extend(timezone);

function SettlementAgentDeposits() {
    const brand = getBrand();
    const isMonthly = brand.key === 'fast';
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)
    const [retryLoadingIds, setRetryLoadingIds] = useState(new Set())
    const retryKeysRef = useRef(new Map())

    const genUUID = () => (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

    // 주간 정산 기간 생성 (inbiz)
    const generateWeeklyPeriods = () => {
        const periods = [];
        const today = dayjs();

        // 첫 번째 기간: 2026-04-01 ~ 2026-04-12
        periods.push({
            value: '2026-04-01~2026-04-12',
            startDate: '2026-04-01',
            endDate: '2026-04-12',
            label: '2026-04-01 ~ 2026-04-12'
        });

        // 이후 주단위: 월~일 (일요일 정산 완료 주까지만 포함)
        let weekStart = dayjs('2026-04-13');
        while (weekStart.add(6, 'day').isBefore(today, 'day') || weekStart.add(6, 'day').isSame(today, 'day')) {
            const weekEnd = weekStart.add(6, 'day');
            periods.push({
                value: `${weekStart.format('YYYY-MM-DD')}~${weekEnd.format('YYYY-MM-DD')}`,
                startDate: weekStart.format('YYYY-MM-DD'),
                endDate: weekEnd.format('YYYY-MM-DD'),
                label: `${weekStart.format('YYYY-MM-DD')} ~ ${weekEnd.format('YYYY-MM-DD')}`
            });
            weekStart = weekStart.add(7, 'day');
        }

        return periods.reverse(); // 최신순
    };

    // 월간 정산 기간 생성 (fast): 2025-12 ~ 현재월
    const generateMonthlyPeriods = () => {
        const periods = [];
        const today = dayjs();
        let cursor = dayjs('2025-12-01');
        while (cursor.isBefore(today, 'month') || cursor.isSame(today, 'month')) {
            const ym = cursor.format('YYYY-MM');
            periods.push({
                value: ym,
                settlementMonth: ym,
                startDate: cursor.startOf('month').format('YYYY-MM-DD'),
                endDate: cursor.endOf('month').format('YYYY-MM-DD'),
                label: ym,
            });
            cursor = cursor.add(1, 'month');
        }
        return periods.reverse();
    };

    const [periodList] = useState(() => isMonthly ? generateMonthlyPeriods() : generateWeeklyPeriods());
    const [selectedPeriod, setSelectedPeriod] = useState(() => {
        return periodList.length > 0 ? periodList[0].value : '';
    });

    const getSelectedPeriodObj = () => {
        return periodList.find(p => p.value === selectedPeriod) || periodList[0];
    };

    useEffect(() => {
        dispatch(change_Current_Location("영업자입금확정내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    const handlePeriodChange = (event) => {
        setSelectedPeriod(event.target.value);
        setPage(1);
        setReload(e => !e);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, selectedPeriod])

    const ListData = async () => {
        if (page === 1) setSpinner(true)

        const period = getSelectedPeriodObj();

        await axios.get(process.env.REACT_APP_API + "/api/agent-payout/confirm", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                ...(isMonthly
                    ? { settlementMonth: period?.settlementMonth }
                    : { startDate: period?.startDate, endDate: period?.endDate }),
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code === 1000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.payoutList ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.payoutList ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            setSpinner(false)
        });
    }

    const handleRetry = async (id, name) => {
        if (!window.confirm(`"${name}" 건을 재처리 하시겠습니까?`)) return;

        // 같은 건 재시도 시 동일 UUID 재사용 (네트워크 에러/409 시 중복 이체 방지)
        const key = retryKeysRef.current.get(id) || genUUID();
        retryKeysRef.current.set(id, key);

        setRetryLoadingIds(prev => new Set(prev).add(id));
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/agent-payout/retry",
                { id, idempotencyKey: key },
                {
                    withCredentials: true,
                    headers: { 'Idempotency-Key': key },
                    validateStatus: (s) => (s >= 200 && s < 300) || s === 409,
                }
            );

            if (response.status === 409) {
                alert("해당 건이 처리 중입니다. 잠시 후 다시 시도해주세요.");
                setPage(1);
                setReload(e => !e);
                return; // UUID 유지 → 재조회 시 동일 키 사용
            }

            const tmp = response?.data;
            if (tmp?.code === 1000) {
                const status = tmp?.data?.status;
                if (status === 'PENDING') {
                    alert("송금 확인 중입니다. 10분 내 최종 상태가 반영됩니다.");
                } else {
                    alert(tmp?.msg || "재이체 요청이 완료되었습니다.");
                }
                retryKeysRef.current.delete(id);
                setPage(1);
                setReload(e => !e);
            } else if (tmp?.code === 9999) {
                navigate('/');
            } else {
                const reason = (tmp?.data?.response?.result?.resultMsg || '').trim();
                alert(reason
                    ? `재처리에 실패했습니다.\n\n${reason}`
                    : (tmp?.msg || "재처리에 실패했습니다."));
                retryKeysRef.current.delete(id);
                setPage(1);
                setReload(e => !e);
            }
        } catch (error) {
            console.error(error);
            alert("재처리 요청 중 오류가 발생했습니다. 동일 버튼으로 재시도해주세요.");
            // UUID 유지 → 중복 이체 방지
        } finally {
            setRetryLoadingIds(prev => { const s = new Set(prev); s.delete(id); return s; });
        }
    };

    const tableHeaderData = [
        { "no": 1, "text": "정산기간", "width": "155px", "textAlign": "center" },
        { "no": 3, "text": "영업자명", "width": "200px", "textAlign": "center" },
        { "no": 4, "text": "입금액", "width": "110px", "textAlign": "center" },
        { "no": 5, "text": "예금주", "width": "150px", "textAlign": "center" },
        { "no": 7, "text": "은행", "width": "120px", "textAlign": "center" },
        { "no": 6, "text": "입금계좌", "width": "160px", "textAlign": "center" },
        { "no": 10, "text": "적요", "width": "120px", "textAlign": "center" },
        { "no": 7.5, "text": "상계사유", "width": "150px", "textAlign": "center" },
        { "no": 8, "text": "입금방식", "width": "90px", "textAlign": "center" },
        { "no": 9, "text": "처리상태", "width": "100px", "textAlign": "center" },
        { "no": 10, "text": "실패사유", "width": "100px", "flex": 1, "textAlign": "center" },
        { "no": 11, "text": "재처리", "width": "70px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            const period = getSelectedPeriodObj();
            let list = (listTrxData ?? []).filter(item => {
                if (item.status === "보류" || item.transfer_status === "보류") return false;
                if (!period) return true;
                // settlement_month로 필터링
                if (item.settlement_month) {
                    return item.settlement_month === period.label || item.settlement_month === period.value;
                }
                // fallback: requested_at 날짜로 필터링
                const dateStr = (item.requested_at || item.created_at || item.settlement_date || '').split(' ')[0];
                if (dateStr) {
                    return dateStr >= period.startDate && dateStr <= period.endDate;
                }
                return true;
            });
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let settlementPeriod = data.settlement_month || '-';
                let date = data.requested_at ? data.requested_at.split(' ') : [];

                tableBodyData.push([
                    { no: 1, text: settlementPeriod, width: "155px", textAlign: "center", style: { fontSize: "12px" } },
                    { no: 3, text: data.co_nm || data.agent_name || '-', width: "200px", textAlign: "left" },
                    { no: 4, text: changeNum(data.final_amount || data.requested_amount), width: "110px", textAlign: "right" },
                    { no: 5, text: data.account_holder, width: "150px", textAlign: "center" },
                    { no: 7, text: data.bank_name, width: "120px", textAlign: "center" },
                    { no: 6, text: data.account_number, width: "160px", textAlign: "left" },
                    { no: 10, text: data.payout_memo || data.remark || data.memo || '-', width: "120px", textAlign: "left" },
                    { no: 7.5, text: <span title={data.offset_memo || ''}>{data.offset_memo || '-'}</span>, width: "150px", textAlign: "left" },
                    { no: 8, text: data.payout_method || '-', width: "90px", textAlign: "center" },
                    {
                        no: 9, text: (
                            data.transfer_status == "송금 완료"
                                ?
                                <div style={{ color: "green", fontWeight: "bold" }}>
                                    {data.transfer_status}
                                </div>
                                :
                                data.transfer_status == "송금 실패"
                                    ?
                                    <div style={{ color: "red", fontWeight: "bold" }}>
                                        {data.transfer_status}
                                    </div>
                                    :
                                    <div style={{ color: "gray", fontWeight: "bold" }}>
                                        {data.transfer_status || '대기'}
                                    </div>
                        ), width: "100px", textAlign: "center"
                    },
                    {
                        no: 10,
                        text: (() => {
                            const reason = data.transfer_status === "송금 실패" ? (data.transfer_fail_reason || "-") : "-";
                            return <span title={reason !== '-' ? reason : ''}>{reason}</span>;
                        })(),
                        width: "100px", flex: 1, textAlign: "center",
                        style: data.transfer_status === "송금 실패" ? { color: "red" } : {}
                    },
                    {
                        no: 11,
                        text: data.transfer_status === "송금 실패"
                            ? (
                                <button
                                    onClick={() => handleRetry(data.id, data.co_nm || data.agent_name)}
                                    disabled={retryLoadingIds.has(data.id)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: "1px solid #f59e0b",
                                        backgroundColor: retryLoadingIds.has(data.id) ? "#e5e7eb" : "#fbbf24",
                                        color: retryLoadingIds.has(data.id) ? "#9ca3af" : "#92400e",
                                        cursor: retryLoadingIds.has(data.id) ? "not-allowed" : "pointer",
                                        fontWeight: "bold"
                                    }}
                                >
                                    재처리
                                </button>
                            )
                            : "",
                        width: "70px", textAlign: "center"
                    },
                ]);
            }
            setCombineData(tableBodyData);
        }
    }, [listTrxData, selectedPeriod]);

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const excelBtn = async () => {
        const period = getSelectedPeriodObj();

        await axios.get(process.env.REACT_APP_API + "/api/agent-payout/confirm/excel", {
            withCredentials: true,
            params: {
                ...(isMonthly
                    ? { settlementMonth: period?.settlementMonth }
                    : { startDate: period?.startDate, endDate: period?.endDate }),
                agentId: selectedText || undefined,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.payoutList ?? [])
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                let settlementPeriod = t.settlement_month || '-';

                try {
                    arr.push({
                        "정산기간": settlementPeriod,
                        "영업자명": t.co_nm || t.agent_name || '-',
                        "입금액": t.final_amount || t.requested_amount,
                        "예금주": t.account_holder,
                        "입금계좌": t.account_number,
                        "은행": t.bank_name,
                        "적요": t.payout_memo || t.remark || t.memo || '-',
                        "상계사유": t.offset_memo || '-',
                        "입금방식": t.payout_method || '-',
                        "처리상태": t.transfer_status || '대기',
                        "실패사유": t.transfer_fail_reason || "",
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        const period = getSelectedPeriodObj();
        Excel(arr, period?.label)
    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                        <label style={{ minWidth: "80px", fontWeight: "500" }}>정산기간:</label>
                        <select
                            value={selectedPeriod}
                            onChange={handlePeriodChange}
                            style={{
                                padding: "8px 12px",
                                border: "1px solid #d1d5db",
                                borderRadius: "4px",
                                fontSize: "14px",
                                minWidth: "280px"
                            }}
                        >
                            {periodList.map((period) => (
                                <option key={period.value} value={period.value}>
                                    {period.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ display: "flex", flexDirection: "row-reverse", marginBottom: "10px" }}>
                    <div className='excel-disable' style={{ width: "auto" }}>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                    </div>
                </div>
                <div style={{ width: "100%" }}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"700px"}
                    />
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData, settlementPeriod) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const dateStr = settlementPeriod ? `_${settlementPeriod.replace(/[~ ]/g, '_')}` : '';
    const excelFileName = `입금확정 영업자내역${dateStr}`;

    const headerRow = [
        "정산기간", "영업자명", "입금액", "예금주", "은행", "입금계좌", "적요", "상계사유", "입금방식", "처리상태", "실패사유"
    ];

    const bodyRows = excelData.map((data) => ([
        data.정산기간, data.영업자명, Number(data.입금액), data.예금주, data.은행, data.입금계좌, data.적요, data.상계사유, data.입금방식, data.처리상태, data.실패사유
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementAgentDeposits
